import { render, staticRenderFns } from "./general-edit-tab.vue?vue&type=template&id=88f2afce&scoped=true"
import script from "./general-edit-tab.vue?vue&type=script&lang=js"
export * from "./general-edit-tab.vue?vue&type=script&lang=js"
import style0 from "./general-edit-tab.vue?vue&type=style&index=0&id=88f2afce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88f2afce",
  null
  
)

export default component.exports